/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './PreferencesLayout.scss';
import './MessageCenterLayout.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';

import { getDefaultRequestStatus } from 'state/requests/RequestStatusSelectors';
import MessageCenterContainer from 'components/layouts/MessageCenter/MessageCenterContainer';
import {
  addLRNEnabled,
  owned529OnlyBrandingEnabled,
  retailTracEnabled
} from 'services/FeatureFlags';
import {
  getHasRetailTracAccountOnly,
  getThemeNameFromAccounts,
  mapProductTypeToiiFooterBoolean
} from 'state/account/AccountSelectors';
import { getThemeName, isMobile } from 'state/view/ViewSelectors';
import LegalReferenceNumber from 'components/layouts/LegalReferenceNumber/LegalReferenceNumber';
import { hasAppLoaded } from '../../state/analytics/analyticsSelectors';
import AAMFooterContainer from './Footer/FooterUtil';
import {legalReferenceNumbers} from 'services/Content';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';

const MessageCenterLayout = ({
                               appLoaded,
                               footerProductTypes,
                               isMobileApp,
                               requestStatus = {},
                               className = '',
                               themeName,
                               hasRetailTracAccountOnly,
                               isCustomerWebView
                             }) => {
  const hasFullPageError = Object.values(requestStatus).some(
    (status) => status === REQUEST_STATES.error
  );
  //const isPreferencesBarLoading = Object.values(requestStatus).some(status => status !== REQUEST_STATES.received);

  return (
    <Fragment>
      {retailTracEnabled() && hasRetailTracAccountOnly && !hasFullPageError && !isCustomerWebView && (
        <Redirect to={'/smallbusiness-external-authorization'} />
      )}

      <div className="message-center-layout-container">
        <div
          className={`preferences-layout-container ${themeName} ${className}`}>
          {/*<PreferencesBar hasError={hasFullPageError}*/}
          {/*isPreferencesBarLoading={isPreferencesBarLoading}*/}
          {/*backPath="/dashboard" />*/}

          <MessageCenterContainer
            hasError={hasFullPageError}
            containerClass="message-center-layout"
          />
        </div>
        {addLRNEnabled() && (
          <div className="message-center-lrn-layout-footer">
            <LegalReferenceNumber
              providedLegalNumber={legalReferenceNumbers.MESSAGE_CENTER_LRN}
            />
          </div>
        )}
        <div className={addLRNEnabled() ? 'lrn-footer' : ''}>
          <AAMFooterContainer
            isMobileParam={isMobileApp}
            footerProductTypes={footerProductTypes}
            appLoaded={appLoaded}
          />
        </div>
      </div>
    </Fragment>
  );
};


const mapStateToProps = (state) => ({
  footerProductTypes: mapProductTypeToiiFooterBoolean(state),
  appLoaded: hasAppLoaded(state),
  isMobileApp: isMobile(state),
  requestStatus: getDefaultRequestStatus(state),
  themeName: owned529OnlyBrandingEnabled()
    ? getThemeNameFromAccounts(state)
    : getThemeName(state),
  hasRetailTracAccountOnly: getHasRetailTracAccountOnly(state),
  isCustomerWebView: getCustomerWebView(state),
});

export default connect(mapStateToProps)(MessageCenterLayout);
